import React from 'react';

import type { IconsList as Icons } from '@mint-lib/icons/allIcons';
import styled from '@mint-lib/styled';
import { IconButtonProps } from '@mui/material/IconButton';

import { IconProps } from '../../components/Icon/Icon.jsx';
import IconButton from '../../components/IconButton/IconButton.jsx';

interface Props extends IconButtonProps {
  /**
   * The icon element.
   */
  icon?: Icons;

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size?: IconButtonProps['size'];

  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   */
  edge?: IconButtonProps['edge'];
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color?: IconButtonProps['color'];

  /**
   * Aria tag for accessibility
   */
  ariaLabel?: string;

  /**
   * If `true`, the button will be disabled.
   */
  disabled?: boolean;
  /**
   * If `true`, the ripple will be disabled.
   */
  disableRipple?: boolean;

  onClick?: IconButtonProps['onClick'];

  IconProps?: IconProps;
}

const UnStyledIconButton = (props: Props) => {
  return <StyledIconButton {...props} variant="icon" color="secondary" />;
};

const StyledIconButton = styled(IconButton)`
  &:hover {
    background-color: transparent !important;
  }
  &:focus {
    box-shadow: none !important;
  }
  &:active {
    background-color: transparent !important;
  }
`;

export default UnStyledIconButton;
